import { Avatar, AvatarGroup, Box, IconButton, Typography } from '@mui/material';
import Images from '../../../../Assets/assetHelper';
import { useStyles } from '../styles';
import { DiscoverGroupCardProps } from '../../../../interfaces/Groups';

const DiscoverGroupCard: React.FC<DiscoverGroupCardProps> = ({ groupName, memberCount, members, onJoinClick }) => {
  const classes = useStyles();
  return (
    <Box className={classes.GroupCard}>
      <img src={Images.Images.entreprenursOfKen42} alt="Discover Group" style={{ borderRadius: '10px 10px 0px 0px' }} />
      <Box component={'div'} sx={{ padding: '10px 0px 0px 20px' }}>
        <Typography className={classes.classSixteen}>{groupName}</Typography>
        <Typography className={classes.cardActionContainerTypo}>{memberCount} members</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', paddingTop: '2px' }}>
          <AvatarGroup max={4} className={classes.cardAvatarGroup}>
            {members.map((member, index) => (
              <Avatar key={index} alt={member.name} src={member.imageUrl} sx={{ width: '18px', height: '18px', fontSize: '12px' }} />
            ))}
          </AvatarGroup>
          <Typography sx={{ fontSize: '9px', fontWeight: '400' }}>
            {members[0].name} and {members.length - 1} friends are members
          </Typography>
        </Box>

        <div className={classes.cardActionContainer}>
          <Typography sx={{ fontSize: '10.5px', fontWeight: '500' }}>Join Group</Typography>
          <IconButton sx={{ marginRight: '10px' }} onClick={onJoinClick}>
            <img src={Images.Icons.ArrowForward} alt="ArrowForward" height={'12px'} width={'12px'} />
          </IconButton>
        </div>
      </Box>
    </Box>
  );
};

export default DiscoverGroupCard;
